export const getOptionValue = (value, from, to) => {
  if (typeof value === 'boolean') {
    return String(value);
  }
  if (typeof value === 'string') {
    return value;
  }
  return `${from ? from : ''}${from && to ? '-' : ''}${to ? to : ''}`;
};